import { Entity } from '@adornis/baseql/decorators.js';
import { KooperationsPartner } from './KooperationsPartner.js';
import { Partner } from './Partner.js';

/**
 * @entity University
 */
@Entity()
export class University extends Partner {
  static override _class = 'University';

  override get type() {
    return KooperationsPartner.UNIVERSITY;
  }
}
